class AuthBase {
  static #height = 550;

  static #width = 550;

  static #left = (window.screen.width / 2) - (this.#width / 2);

  static #top = (window.screen.height / 2) - (this.#height / 2);

  static popupFeatures = 'toolbar=no'
    + ',location=no'
    + ',directories=no'
    + ',status=no'
    + ',menubar=no'
    + ',scrollbars=yes'
    + ',resizable=yes'
    + ',copyhistory=no'
    + `,width=${this.#width}`
    + `,height=${this.#height}`
    + `,top=${this.#top}`
    + `,left=${this.#left}`;

  store; // Vue

  get popupFeatures() {
    return AuthBase.popupFeatures;
  }

  /* abstract */ async handleCode(code) {
    throw new Error('Not implemented!');
  }

  /* abstract */ async fetchAuthUrl() {
    throw new Error('Not implemented!');
  }

  constructor(store) {
    this.store = store;
  }

  async show() {
    await this.fetchAuthUrl();
    return this.popupAuth();
  }

  async popupAuth() {
    const authUrl = this.store.$data.authorizationUrl;
    const target = this.constructor.name;

    this.store.$data.popup = window.open(authUrl, target, AuthBase.popupFeatures);

    if (!this.store.$data.popup) {
      return Promise.reject(new Error('Popup has not been opened!'));
    }

    return new Promise((resolve, reject) => {
      const handler = this.handleMessage.bind(this, resolve, reject);
      window.addEventListener('message', handler, { once: true, capture: true });
      this.store.$data.polling = setInterval(() => {
        if (this.store.$data.popup && this.store.$data.popup.closed) {
          clearInterval(this.store.$data.polling);
          this.store.$data.popup = undefined;
          reject(new Error('Authentication popup has been closed!'));
        }
      }, 1000, this);
    });
  }

  async handleMessage(resolve, reject, event) {
    const propertyNames = Object.getOwnPropertyNames(event.data);
    if (
      !propertyNames.includes('type')
      || (!propertyNames.includes('code') || !propertyNames.includes('error'))
    ) {
      console.warn('Adding new event listener!');
      const handler = this.handleMessage.bind(this, resolve, reject);
      window.addEventListener('message', handler, { once: true, capture: true });
      return;
    }

    if (!this.store.$data.popup) return;

    clearInterval(this.store.$data.polling);
    this.store.$data.popup.close();

    if (event.data.code) {
      try {
        await this.handleCode(event.data.code);
      } catch (e) {
        this.store.$data.popup = undefined;
        reject(e.error.message);
      }
      this.store.$data.popup = undefined;
      resolve();
    } else {
      // Handle error
      this.store.$data.popup = undefined;
      reject();
    }
  }
}

export default AuthBase;
